import { SxProps, Theme } from '@mui/material';
import { ReactElement, ReactNode } from 'react';

export enum FormControlLabelPlacementProps {
  Bottom = 'bottom',
  End = 'end',
  Start = 'start',
  Top = 'top',
}

export interface FormControlLabelProps {
  control: ReactElement;
  label: ReactNode;
  value?: string;
  labelPlacement?: FormControlLabelPlacementProps;
  /** Style overrides, forwarded to the underlying MUI FormControlLabel. */
  sx?: SxProps<Theme>;
}
